(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sword-mobile-brands"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sword-mobile-brands')) {
    customElements.define('sword-mobile-brands', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const details = this.querySelector('details');
        const summary = this.querySelector('summary');
        if (!details || !summary) return;
        document.addEventListener('click', event => {
          if (!this.contains(event.target)) details.open = false;
        }, { signal: this.controller.signal });
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape' && details.open) {
            event.preventDefault();
            details.open = false;
            summary.focus();
          }
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
